export default {
  disciplines: {
    title: 'Disciplines',
    list: [
      { t: 'En réanimation adulte', f: `$spe ~ "AD REA"` },
      { t: 'En médecine adulte (hors can, med, rad)', f: `$spe ~ "AD MED"` },
      { t: 'En cancérologie adulte', f: `$spe ~ "AD CAN"` },
      { t: 'En radiologie adulte', f: `$spe ~ "AD RAD"` },
      { t: 'En chirurgie adulte', f: `$spe ~ "AD CHIR"` },
      { t: 'En réanimation néonatale', f: `$spe ~ "NEO REA"` },
      { t: 'En service de dialyse adulte', f: `$spe ~ "AD REA"` }
    ]
  }
}
